// UI strings for taking a Finnish approval back (2026-10-06, src/dictionary/approval.ts):
// "Peru hyväksyntä" on a reviewed meaning and "Kumoa" on the toast right after "Hyväksy".
// Finnish (default) and English side by side. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const glossApprovalFi = {
  /** On a reviewed Finnish meaning, next to "tarkistettu · Roosa". */
  unapprove: 'Peru hyväksyntä',
  /** The toast right after "Hyväksy". */
  approved: 'Suomennos hyväksytty.',
  undo: 'Kumoa',
  undoLabel: 'Kumoa hyväksyntä',
};

export type GlossApprovalMessages = typeof glossApprovalFi;

export const glossApprovalEn: GlossApprovalMessages = {
  unapprove: 'Take back approval',
  approved: 'Finnish meaning approved.',
  undo: 'Undo',
  undoLabel: 'Undo the approval',
};

// Messages.glossApproval (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('glossApproval', glossApprovalFi, glossApprovalEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof glossApprovalFi> {}
}
